import React, { useState, useEffect } from 'react';
import Avatar from 'react-avatar';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import Spinner from '../../Spinner';
import moment from 'moment';
import 'react-toastify/dist/ReactToastify.css';
import {
  TOUR_REQUEST_PDF,
  TOUR_REQUEST_RESEND,
  TOUR_REQUEST_HISTORY,
  TOUR_REQUEST_HISTORY_MULTI_DELETE,
	UPDATE_TOUR_REQUEST,
  MY_PROFILE
} from '@api';
import { useQuery, useMutation } from '@apollo/client';
import {
  Row,
  Col,
  Table,
  FormGroup,
  Label,
  UncontrolledButtonDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import GuestCard from './GuestCard';
import SidebarRight from '../../SidebarRight';
import Select from 'react-select';
import { Icon } from '@assets';
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
  useAsyncDebounce,
  useRowSelect,
} from 'react-table';
const appoinmentTypes = {
  inperson: 'In-Person with Broker',
  without_broker: 'Send without Broker',
  virtual: 'Virtual Tour',
  self_guided: 'Self-Guided',
};

const statusTypes = {
  sent_not_confirmed: 'Sent - Not Confirmed',
  resent_not_confirmed: 'Resent - Not Confirmed',
  confirmed: 'Confirmed',
  delivery_failed: 'Not Delivered'
};

const guestCardStatuses = [
  { value: 'sent_not_confirmed', label: 'Sent - Not Confirmed' },
  { value: 'resent_not_confirmed', label: 'Resent - Not Confirmed' },
  { value: 'confirmed', label: 'Confirmed' },
  { value: 'delivery_failed', label: 'Not Delivered' },
];

const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return (
      <>
        <input
          type='checkbox'
          className='custom-checkbox'
          ref={resolvedRef}
          {...rest}
        />
      </>
    );
  }
);

function GlobalFilter({
  preGlobalFilteredRows: _preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
}) {
  const [value, setValue] = React.useState(globalFilter);

  const onChange = useAsyncDebounce((val) => {
    setGlobalFilter(val || undefined);
  }, 200);

  return (
    <div className='search-bar d-inline-block inline-block w-100'>
      <FormGroup className='mb-0 w-auto d-inline-block'>
        <div className='d-flex align-items-center w-100'>
          <Label
            for='guest-search'
            className='mb-0 w-auto d-inline-flex align-items-center mr-2'
          >
            <Icon icon='search' />
          </Label>
          <input
            id='guest-search'
            value={value || ''}
            onChange={(e) => {
              setValue(e.target.value);
              onChange(e.target.value);
            }}
            placeholder='Search by keywords'
            className='w-100'
          />
        </div>
      </FormGroup>
    </div>
  );
}

const statusColorForMobile = (statusLabel) => {
  const value = (statusLabel || '').toLowerCase();
  if (!value) return '#6b7280';
  if (value.includes('not delivered')) return '#dc2626';
  if (value.includes('confirmed') || value.includes('opened')) return '#25a55f';
  if (value.includes('resent')) return '#f2994a';
  if (value.includes('not opened') || value.includes('not confirmed'))
    return '#f25f5c';
  return '#2563eb';
};

const formatStatusLabel = (status) => {
  if (!status) {
    return 'Status';
  }
  if (statusTypes[status]) {
    return statusTypes[status];
  }
  const cleaned = status.replace(/_/g, ' ').toLowerCase();
  return cleaned.replace(/\b\w/g, (char) => char.toUpperCase());
};

const mobileStyles = {
  filterContainer: {
    marginBottom: '16px',
    padding: '12px',
    borderRadius: '16px',
    background: '#f8fafc',
    boxShadow: '0 6px 20px rgba(15, 34, 58, 0.08)',
  },
  filterHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  filterRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '13px',
    color: '#475569',
  },
  filterLabel: {
    fontWeight: 600,
  },
  mobileActionsWrapper: {
    display: 'flex',
    gap: '12px',
    marginTop: '8px',
    flexWrap: 'wrap',
  },
  actionButton: {
    flex: '1 1 140px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '12px 14px',
    borderRadius: '12px',
    boxShadow: '0 6px 16px rgba(15, 34, 58, 0.12)',
    fontSize: '0.9rem',
    fontWeight: 600,
  },
  listWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
    paddingBottom: '72px',
  },
  card: {
    background: '#ffffff',
    borderRadius: '18px',
    padding: '18px',
    boxShadow: '0 12px 32px rgba(15, 34, 58, 0.12)',
    border: '1px solid #eef2f7',
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '12px',
  },
  headerLeft: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    flex: '1 1 auto',
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  checkboxWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    fontSize: '16px',
    fontWeight: 700,
    color: '#1f2933',
  },
  subtitle: {
    fontSize: '13px',
    color: '#64748b',
  },
  headerRight: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '10px',
  },
  statusBadge: (statusLabel) => ({
    fontSize: '13px',
    fontWeight: 600,
    color: statusColorForMobile(statusLabel),
    background: `${statusColorForMobile(statusLabel)}12`,
    borderRadius: '999px',
    padding: '6px 12px',
    textAlign: 'center',
    minWidth: '105px',
    textTransform: 'capitalize',
  }),
  detailSection: {
    marginTop: '14px',
    borderTop: '1px solid #f1f5f9',
    paddingTop: '14px',
    display: 'grid',
    rowGap: '12px',
  },
  detailRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  detailLabel: {
    fontSize: '12px',
    color: '#94a3b8',
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
  },
  detailValue: {
    fontSize: '13px',
    color: '#334155',
    fontWeight: 500,
    lineHeight: 1.45,
  },
  actionRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    marginTop: '16px',
  },
  smallButton: {
    flex: '1 1 48%',
    borderRadius: '12px',
    fontSize: '13px',
    fontWeight: 600,
    padding: '10px 12px',
  },
  iconButton: {
    flex: '0 0 48%',
    borderRadius: '12px',
    fontSize: '13px',
    fontWeight: 600,
    padding: '10px 12px',
  },
};

export default function GuestHistory(props) {
  const [guestCards, setGuestCards] = useState([]);
  const [isCheckedId, setIsCheckedId] = useState([]);
  const [resendMailId, setResendMailId] = useState(null);
  const [allDeleteModal, setAllDeleteModal] = useState(false);
  const [resendModal, setResendModal] = useState(false);
  const [isChecked, setIsChecked] = useState([]);
  const [refetch, setRefetch] = useState(false);
  const [isProgress, setIsProgress] = useState(false);
  const [guestCardList, setGuestCardList] = useState('loading');
	const [editGuestCard, setEditGuestCard] = useState(null);
  const [updateProfile, setUpdateProfile] = useState(false);

  useQuery(MY_PROFILE, {
    onCompleted: (data) => {
      if (data.myProfile) {
        if (data.myProfile.isProfileCompleted) {
          setUpdateProfile(false);
        } else {
          setUpdateProfile(true);
        }
      }
    }
  })

  const {
    data: guestCardsData,
    loading: guestLoading,
    error: guestError,
    refetch: guestRefetch,
  } = useQuery(TOUR_REQUEST_HISTORY, {
    onCompleted: (data) => {},
    onError: (e) => {
      console.log(e, 'error');
    },
  });

  useEffect(() => {
    if (refetch === true) {
      guestRefetch();
      setRefetch(false);
    }
  }, [refetch]);

  const [
    guestCardPDF,
    {
      data: guestCardPDFData,
      loading: guestCardPDFLoading,
      error: guestCardPDFError,
    },
  ] = useMutation(TOUR_REQUEST_PDF, {
    onCompleted: (data) => {
      data.tourRequestPdf.guestPdfUrl &&
        window.open(data.tourRequestPdf.guestPdfUrl, '_blank')?.focus();
      toast(
        () => (
          <a href={data.tourRequestPdf.guestPdfUrl} target='_blank' download>
            Click here to download PDF
          </a>
        ),
        { type: 'success' }
      );
    },
    onError: (e) => {
      console.log(e);
      toast(e, { type: 'error' });
    },
  });

	const [updateTourRequest] = useMutation(UPDATE_TOUR_REQUEST, {
		onCompleted: (data) => {
			if (
				data.updateTourRequest.errors &&
				data.updateTourRequest.errors.length > 0
			) {
				data.updateTourRequest.errors.map((err) =>
					toast(err, { type: 'error' })
				);
			} else {
				toast(data.updateTourRequest.message, { type: 'success' });
			}
		},
		onError: (e) => {
			console.log(e, 'updated client ON ERROR');
		},
	})

	const updateStatus = (guestCard, value) => {
		updateTourRequest({
			variables: {
				...guestCard,
				id: Number(guestCard.id),
				status: value,
				emailGuestCard: false
			}
		})
	}

  const [guestResendMail, { data: guestResendData }] = useMutation(
    TOUR_REQUEST_RESEND,
    {
      onCompleted: (data) => {
        if (data.tourRequestResend.errors === null) {
          setResendModal(!resendModal);
          toast(data.tourRequestResend.message, { type: 'success' });
          setIsProgress(false);
					setRefetch(true);
        } else {
          toast(data.tourRequestResend.message, { type: 'error' });
        }
      },
      onError: (e) => {
        console.log(e);
        toast(e, { type: 'error' });
      }
    }
  );

  const addNewguestHistory = () => {
    setSidebarState(true);
  };

  const downloadGuestCardPDF = (id = null) => {
    guestCardPDF({ variables: { id: parseInt(id) } });
  };

  const resendMail = (id = null) => {
    setResendMailId(parseInt(id));
    setResendModal(true);
  };

  const handleResendMail = async () => {
    setIsProgress(true);
    await guestResendMail({ variables: { id: resendMailId } });
  };

  const onResendPopup = () => {
    if (resendMailId) {
      setResendModal(!resendModal);
    }
  };

  const [guestMultiDelete] = useMutation(TOUR_REQUEST_HISTORY_MULTI_DELETE, {
    onCompleted: (data) => {
      setAllDeleteModal(!allDeleteModal);
      toast(data.deleteTourRequests.message, { type: 'success' });
      setIsProgress(false);
    },
    refetchQueries: [TOUR_REQUEST_HISTORY],
    onError: (e) => {
      console.log(e);
    },
  });

  useEffect(() => {
    setIsCheckedId([]);
    var isSelectedIds = [];
    isChecked.map(function (key, index) {
      isSelectedIds.push(parseInt(key.original.node.id));
    });
    setIsCheckedId(isSelectedIds);
  }, [isChecked]);

  const handleDeleteAll = async () => {
    setIsProgress(true);
    await guestMultiDelete({
      variables: {
        ids: isCheckedId,
      },
    });
  };

  const handleSingleDelete = (id) => {
    setIsCheckedId([parseInt(id)]);
    setAllDeleteModal(true);
  };

  const onAllDeletePopup = () => {
    if (isCheckedId.length > 0) {
      setAllDeleteModal(!allDeleteModal);
    }
  };

	function handleEdit(id){
		setEditGuestCard(id);
	}

  function handleUpdateProfile () {
		history.push(`/settings`)
	}

  useEffect(() => {
    if (guestCardsData) {
      if (guestCardsData.tourRequests.length === 0) {
        setGuestCardList('noData');
      } else {
        setGuestCards(guestCardsData.tourRequests.edges);
        setGuestCardList('data');
      }
    }
  }, [guestCardsData]);

	const currencyFormatter = new Intl.NumberFormat('en-US', {
    /* style: 'currency', */
    currency: 'USD',
    maximumFractionDigits: 0,
  });

  const columns = React.useMemo(
    () => [
      {
        Header: 'Client',
        accessor: 'node.client.name',
        Cell: ({ value, row }) => (
          <div>
            <Avatar
              name={value ? value : '-'}
              className='mr-2 text-white'
              round={true}
              size='30'
            />{' '}
            {value ? value : '-'}
          </div>
        ),
      },
			{
        Header: 'Action',
        accessor: 'node.id',
        disableSortBy: true,
        Cell: ({ value, row }) => (
          <div>
            <UncontrolledButtonDropdown>
              <DropdownToggle caret>
                <Icon icon='bars' />
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  onClick={() => {
                    downloadGuestCardPDF(value);
                    // setSidebarState(true);
                    // history.push(`/clients/edit/${value}`);
                  }}
                >
                  Download PDF
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem onClick={() => resendMail(value)}>
                  Resend Email
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem onClick={() => handleEdit(value)}>
                  Edit Guest Card
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem onClick={() => handleSingleDelete(value)}>
                  Delete
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          </div>
        ),
      },
      {
        Header: 'Email',
        accessor: 'node.client.email',
        Cell: ({ value, row }) => <div>{value ? value : '-'}</div>,
      },
      {
        Header: 'Phone',
        accessor: 'node.client.phone',
        Cell: ({ value, row }) => <div>{value ? value : '-'}</div>,
      },
      {
        Header: 'Community',
        accessor: 'node.property.name',
        Cell: ({ value, row }) => (
          <>
            {value ? (
              row.original.node.property.webLink ? (
                <a
                  href={row.original.node.property.webLink}
                  target='_blank'
                >
                  {value}
                </a>
              ) : (
                value
              )
            ) : (
              '-'
            )}
          </>
        ),
      },
      {
        Header: 'Budget',
        accessor: 'node.client.minRent',
        Cell: ({ value, row }) => (
          <div>
            {
              <div>
                {value && row.original.node.client.maxRent ? (
                  <div>
                    {value && '$' + currencyFormatter.format(value)} -{' '}
                    {'$' + currencyFormatter.format(row.original.node.client.maxRent)}{' '}
                  </div>
                ) : value ? (
                  <>{'$' + value + ' & Above'}</>
                ) : row.original.node.client.maxRent ? (
                  <>
                    {'Below ' +
                      '$' +
                      currencyFormatter.format(row.original.node.client.maxRent)}
                  </>
                ) : (
                  '-'
                )}
              </div>
            }
          </div>
        ),
      },
      {
        Header: 'M/I Date',
        accessor: 'node.client.availFrom',
				width: 150,
        Cell: ({ value, row }) => (
          <div>
            {value ? (
              <div>
								{
									value && !row.original.node.client.availTo ? `After ${moment(value).format('L')}` :
									!value && row.original.node.client.availTo ? `Before ${moment(row.original.node.client.availTo).format('L')}` :
									`${moment(value).format('L')} - ${moment(row.original.node.client.availTo).format('L')}`
								}
              </div>
            ) : (
              '-'
            )}
          </div>
        ),
      },
      {
        Header: 'Type',
        accessor: 'node.appointmentType',
        Cell: ({ value, row }) => (
          <div>{value ? appoinmentTypes[value] : '-'}</div>
        ),
      },
      {
        Header: 'Time',
        accessor: 'node.tourAtInLocalTime',
        Cell: ({ value }) => (
          <div>
						{value.split(" ")[0]}<br/>
						{value.split(" ").slice(1, 10).join(" ")}
					</div>
        ),
      },
      {
        Header: 'Status',
        accessor: 'node.status',
				width: 250,
        Cell: ({ value, row}) => (
          // <div>{statusTypes[value]}</div>
					<>
						<Select
							name='status'
							isMulti={false}
							value={guestCardStatuses.find(s => s.value === value)}
							options={guestCardStatuses}
							onChange={(e) => updateStatus(row.original.node, e.value)}
							className='multi-select-client w-100'
							classNamePrefix='default-select'
							placeholder='Select Appointment Type'
						/>
					</>
        ),
      },
    ],
    []
  );

  const totalRecord = guestCards.length;
  const pageSizeOptions = React.useMemo(
    () => [
      { value: '10', label: '10' },
      { value: '15', label: '15' },
      { value: '25', label: '25' },
      { value: '50', label: '50' },
      { value: '75', label: '75' },
      { value: '100', label: '100' },
      { value: totalRecord.toString(), label: 'All' },
    ],
    [totalRecord]
  );

  const defaultColumn = React.useMemo(
    () => ({
      width: 'auto',
    }),
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    selectedFlatRows,
    rows: fullRows,
    state: { pageIndex, globalFilter, sortBy },
    prepareRow,
  } = useTable(
    {
      columns,
      data: guestCards,
      defaultColumn,
      initialState: { pageIndex: 0 },
      autoResetPage: false,
      autoResetExpanded: false,
      autoResetGroupBy: false,
      autoResetSelectedRows: false,
      autoResetSortBy: false,
      autoResetFilters: false,
      autoResetRowState: false,
      autoResetGlobalFilter: false,
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((cols) => [
        {
          id: 'selection',
          Header: ({ getToggleAllPageRowsSelectedProps }) => (
            <IndeterminateCheckbox {...getToggleAllPageRowsSelectedProps()} />
          ),
          Cell: ({ row }) => (
            <IndeterminateCheckbox
              {...row.getToggleRowSelectedProps()}
              onClick={(e) => e.stopPropagation()}
            />
          ),
          width: 50,
          maxWidth: 50,
        },
        ...cols,
      ]);
    }
  );

  useEffect(() => {
    setIsChecked(selectedFlatRows);
  }, [selectedFlatRows]);

  const history = useHistory();
  const [sidebarState, setSidebarState] = useState(false);

  const deleteButton = (
    <Button
      color='red'
      onClick={onAllDeletePopup}
      disabled={isCheckedId.length === 0}
      className='button-dashboard float-right mr-2 mt-sm-0'
    >
      <Icon icon='trash-alt' className='mr-2' />
      Delete
    </Button>
  );

  const guestCountLabel = `${fullRows.length} Guest ${
    fullRows.length === 1 ? 'Card' : 'Cards'
  }`;

  const sortColumnLabel = React.useMemo(() => {
    if (!sortBy || sortBy.length === 0) {
      return 'Default Order';
    }
    const flatHeaders = headerGroups.flatMap((group) => group.headers);
    const match = flatHeaders.find((col) => col.id === sortBy[0].id);
    if (!match) return 'Custom';
    const headerValue = match.Header;
    if (typeof headerValue === 'string') {
      return headerValue;
    }
    if (typeof headerValue === 'function') {
      return 'Custom';
    }
    if (React.isValidElement(headerValue)) {
      return 'Custom';
    }
    return `${match.id}`.replace(/_/g, ' ');
  }, [sortBy, headerGroups]);
  const shouldShowBottomSpace = true;

  useEffect(() => {
    sidebarState
      ? history.push(`/guest-cards/send`)
      : history.push(`/guest-cards`);
  }, [sidebarState]);

  return (
    <>
      {guestLoading && <Spinner />}

      <SidebarRight
        sidebarState={sidebarState}
        sidebarToggle={() => {
          setSidebarState(!sidebarState);
        }}
        sidebarWidth='950px'
        sidebarContent={
          <GuestCard
            sidebarToggle={() => {
              setSidebarState(!sidebarState);
            }}
						sidebarState={sidebarState}
						editGuestCard={editGuestCard}
						setEditGuestCard={setEditGuestCard}
            shouldRefetch={() => setRefetch(true)}
            {...props}
          />
        }
      />

      <Modal isOpen={updateProfile} centered>
        <ModalHeader>Update Profile</ModalHeader>
        <ModalBody>
          Before sending a guest card, update your brokerage name, address, city, state and zip
        </ModalBody>
        <ModalFooter>
          <Button
            color='success'
            // disabled={isProgress}
            onClick={handleUpdateProfile}
          >
            Go to Settings
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={resendModal} toggle={onResendPopup} centered>
        <ModalHeader toggle={onResendPopup}>Confirm Resend</ModalHeader>
        <ModalBody>Are you sure you want to resend Guest Card?</ModalBody>
        <ModalFooter>
          <Button
            color='success'
            disabled={isProgress}
            onClick={handleResendMail}
          >
            Yes
          </Button>
          <Button color='primary' onClick={onResendPopup}>
            No
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={allDeleteModal} toggle={onAllDeletePopup} centered>
        <ModalHeader toggle={onAllDeletePopup}>Delete Confirmation</ModalHeader>
        <ModalBody>
          Are you sure you want to delete {isCheckedId.length} guest histor
          {isCheckedId.length > 1 ? 'ies' : 'y'}?
        </ModalBody>
        <ModalFooter>
          <Button
            color='danger'
            disabled={isProgress}
            onClick={handleDeleteAll}
          >
            Yes
          </Button>
          <Button color='success' onClick={onAllDeletePopup}>
            No
          </Button>
        </ModalFooter>
      </Modal>

      <Row className='mt-md-4'>
        <Col md='12'>
          {guestCards.length > 0 ? (
            <>
              {/* Desktop table */}
              <div className='d-none d-sm-block'>
                <Row className='my-2 d-flex align-items-start'>
                  <Col sm='6'>
                    <GlobalFilter
                      preGlobalFilteredRows={preGlobalFilteredRows}
                      globalFilter={globalFilter}
                      setGlobalFilter={setGlobalFilter}
                    />
                  </Col>
                  <Col sm='6' className='text-lg-right'>
                    {deleteButton}
                  </Col>
                </Row>

                <Table
                  responsive
                  className='client-list text-left min-w-900'
                  {...getTableProps()}
                >
                  <thead>
                    {headerGroups.map((headerGroup) => (
                      <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column) => (
                          <th
                            {...column.getHeaderProps([
                              {
                                style: {
                                  minWidth: column.minWidth,
                                  width: column.width,
                                  maxWidth: column.maxWidth,
                                },
                              },
                              column.getSortByToggleProps(),
                            ])}
                          >
                            {column.render('Header')}
                            <span>
                              {column.isSorted ? (
                                column.isSortedDesc ? (
                                  <>
                                    &nbsp; <Icon icon='sort-down' size='lg' />
                                  </>
                                ) : (
                                  <>
                                    &nbsp; <Icon icon='sort-up' size='lg' />
                                  </>
                                )
                              ) : column.canSort ? (
                                <>
                                  &nbsp; <Icon icon='sort' size='lg' />
                                </>
                              ) : (
                                ''
                              )}
                            </span>
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody {...getTableBodyProps()}>
                    {page.map((row) => {
                      prepareRow(row);
                      return (
                        <tr {...row.getRowProps()}>
                          {row.cells.map((cell) => (
                            <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                          ))}
                        </tr>
                      );
                    })}
                    {page.length <= 2 ? (
                      <tr>
                        <div className='spacer-div'></div>
                      </tr>
                    ) : null}
                    {shouldShowBottomSpace ? (
                      <tr>
                        <div className='rtable-bottom-space'></div>
                      </tr>
                    ) : null}
                  </tbody>
                </Table>
              </div>

              {/* Mobile cards */}
              <div className='d-block d-sm-none'>
                <div style={mobileStyles.filterContainer}>
                  <div style={mobileStyles.filterHeader}>
                    <div onClick={(e) => e.stopPropagation()}>
                      <GlobalFilter
                        preGlobalFilteredRows={preGlobalFilteredRows}
                        globalFilter={globalFilter}
                        setGlobalFilter={setGlobalFilter}
                      />
                    </div>
                    <div style={mobileStyles.filterRow}>
                      <span style={mobileStyles.filterLabel}>{guestCountLabel}</span>
                      <span>Sort By: {sortColumnLabel}</span>
                    </div>
                  </div>
                  <div style={mobileStyles.mobileActionsWrapper}>
                    {React.cloneElement(deleteButton, {
                      className: 'mobile-action-btn',
                      style: {
                        ...mobileStyles.actionButton,
                        ...(deleteButton.props.style || {}),
                      },
                    })}
                  </div>
                </div>

                <div style={mobileStyles.listWrapper}>
                  {page.map((row) => {
                    prepareRow(row);
                    const node = row.original?.node || {};
                    const client = node.client || {};
                    const property = node.property || {};
                    const statusValue = node.status;
                    const statusLabel = formatStatusLabel(statusValue);
                    const selectionProps = row.getToggleRowSelectedProps();
                    const email = client.email || '-';
                    const phone = client.phone || '-';
                    const minRent = client.minRent;
                    const maxRent = client.maxRent;
                    const timeRaw = node.tourAtInLocalTime;
                    const [datePart, ...timeParts] = timeRaw ? timeRaw.split(' ') : [];
                    const timeLabel = timeRaw
                      ? `${datePart} ${timeParts.join(' ')}`.trim()
                      : '-';
                    let budgetLabel = '-';
                    if (minRent && maxRent) {
                      budgetLabel = `$${currencyFormatter.format(minRent)} - $${currencyFormatter.format(
                        maxRent
                      )}`;
                    } else if (minRent) {
                      budgetLabel = `$${currencyFormatter.format(minRent)} & Above`;
                    } else if (maxRent) {
                      budgetLabel = `Below $${currencyFormatter.format(maxRent)}`;
                    }
                    const availFrom = client.availFrom;
                    const availTo = client.availTo;
                    let moveInLabel = '-';
                    if (availFrom && !availTo) {
                      moveInLabel = `After ${moment(availFrom).format('L')}`;
                    } else if (!availFrom && availTo) {
                      moveInLabel = `Before ${moment(availTo).format('L')}`;
                    } else if (availFrom && availTo) {
                      moveInLabel = `${moment(availFrom).format('L')} - ${moment(availTo).format('L')}`;
                    }
                    const appointmentLabel = node.appointmentType
                      ? appoinmentTypes[node.appointmentType]
                      : '-';
                    const communityDisplay = property.name ? (
                      property.webLink ? (
                        <a
                          href={property.webLink}
                          target='_blank'
                          rel='noopener noreferrer'
                          onClick={(e) => e.stopPropagation()}
                        >
                          {property.name}
                        </a>
                      ) : (
                        property.name
                      )
                    ) : (
                      '-'
                    );
                    const statusSelect = (
                      <div onClick={(e) => e.stopPropagation()}>
                        <Select
                          name='status'
                          isMulti={false}
                          value={guestCardStatuses.find((s) => s.value === statusValue) || null}
                          options={guestCardStatuses}
                          onChange={(e) => updateStatus(node, e.value)}
                          className='multi-select-client w-100'
                          classNamePrefix='default-select'
                          placeholder='Select Appointment Type'
                        />
                      </div>
                    );
                    const detailItems = [
                      { label: 'Update Status', value: statusSelect },
                      {
                        label: 'Email',
                        value: email !== '-' ? (
                          <a href={`mailto:${email}`} onClick={(e) => e.stopPropagation()}>
                            {email}
                          </a>
                        ) : (
                          '-'
                        ),
                      },
                      {
                        label: 'Phone',
                        value: phone !== '-' ? (
                          <a href={`tel:${phone}`} onClick={(e) => e.stopPropagation()}>
                            {phone}
                          </a>
                        ) : (
                          '-'
                        ),
                      },
                      { label: 'Community', value: communityDisplay },
                      { label: 'Budget', value: budgetLabel },
                      { label: 'M/I Date', value: moveInLabel },
                      { label: 'Type', value: appointmentLabel || '-' },
                      { label: 'Time', value: timeLabel },
                    ];

                    return (
                      <div key={row.id} style={mobileStyles.card}>
                        <div style={mobileStyles.headerRow}>
                          <div style={mobileStyles.headerLeft}>
                            <div style={mobileStyles.titleRow}>
                              <div
                                style={mobileStyles.checkboxWrapper}
                                onClick={(e) => e.stopPropagation()}
                              >
                                <IndeterminateCheckbox {...selectionProps} />
                              </div>
                              <span style={mobileStyles.title}>
                                {client.name || 'Guest Card'}
                              </span>
                            </div>
                            <div style={mobileStyles.subtitle}>
                              {property.name || 'No community selected'}
                            </div>
                          </div>
                          <div style={mobileStyles.headerRight}>
                            <div style={mobileStyles.statusBadge(statusLabel)}>
                              {statusLabel}
                            </div>
                          </div>
                        </div>

                        <div style={mobileStyles.detailSection}>
                          {detailItems.map((item) => (
                            <div key={item.label} style={mobileStyles.detailRow}>
                              <span style={mobileStyles.detailLabel}>{item.label}</span>
                              <div style={mobileStyles.detailValue}>{item.value}</div>
                            </div>
                          ))}
                        </div>

                        <div style={mobileStyles.actionRow}>
                          <Button
                            color='primary'
                            style={mobileStyles.smallButton}
                            onClick={(e) => {
                              e.stopPropagation();
                              downloadGuestCardPDF(node.id);
                            }}
                          >
                            Download PDF
                          </Button>
                          <Button
                            color='secondary'
                            style={mobileStyles.smallButton}
                            onClick={(e) => {
                              e.stopPropagation();
                              resendMail(node.id);
                            }}
                          >
                            Resend Email
                          </Button>
                          <Button
                            color='light'
                            style={mobileStyles.iconButton}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEdit(node.id);
                            }}
                          >
                            Edit
                          </Button>
                          <Button
                            color='danger'
                            style={mobileStyles.iconButton}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSingleDelete(node.id);
                            }}
                          >
                            Delete
                          </Button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              <Row className='d-flex align-items-center mt-4'>
                <Col md='6'>
                  <FormGroup className='mb-3 mb-md-0'>
                    <Label
                      for='guest-page-size'
                      className='mb-0 w-auto d-inline-block mr-2 mr-md-3'
                    >
                      Showing Entries
                    </Label>
                    <Select
                      inputId='guest-page-size'
                      name='PageSize'
                      defaultValue={pageSizeOptions[0]}
                      options={pageSizeOptions}
                      onChange={(e) => {
                        setPageSize(Number(e.value));
                      }}
                      className='basic-multi-select text-left'
                      classNamePrefix='default-select'
                      menuPlacement='auto'
                    />
                  </FormGroup>
                </Col>

                <div className='justify-content-center'>
                  <ul className='pagination'>
                    <li onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                      <a>
                        <Icon icon='chevron-left' />
                        <Icon icon='chevron-left' />
                      </a>
                    </li>
                    <li onClick={() => previousPage()} disabled={!canPreviousPage}>
                      <a>
                        <Icon icon='chevron-left' />
                      </a>
                    </li>
                    <span className='d-flex align-items-center px-3'>
                      Page &nbsp; <strong>{pageIndex + 1}</strong> &nbsp; of &nbsp;
                      <strong>{pageOptions.length}</strong>
                    </span>
                    <li onClick={() => nextPage()} disabled={!canNextPage}>
                      <a>
                        <Icon icon='chevron-right' />
                      </a>
                    </li>
                    <li onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                      <a>
                        <Icon icon='chevron-right' />
                        <Icon icon='chevron-right' />
                      </a>
                    </li>
                  </ul>
                </div>
              </Row>
            </>
          ) : (
            <>
              {guestCards.length === 0 ? (
                <div className='text-center' style={{ margin: '35vh 0' }}>
                  <h4>You haven't sent any guest cards so far.</h4>
                  <Button
                    onClick={addNewguestHistory}
                    color='success'
                    className='button-dashboard mt-2'
                  >
                    Send a guest card now{' '}
                    <Icon icon='chevron-right' className='ml-2' />
                  </Button>
                </div>
              ) : null}
            </>
          )}
        </Col>
      </Row>
    </>
  );
}
